//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VariableClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type DeleteVariableQueryParameters = {
  id?: number | undefined ;
  revisionId?: number | undefined ;
}

export type SearchVariableQueryParameters = {
  search?: string | undefined ;
  projectId?: number | undefined ;
  revisionId?: number | undefined ;
  isSystem?: boolean | null | undefined ;
  variableType?: Types.VariableType | null | undefined ;
  urlTypes?: Types.UrlType[] | null | undefined ;
  systemVariableTypes?: Types.SystemVariableType[] | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type PatchVariableQueryParameters = {
  id: number ;
  revisionId?: number | undefined ;
}

export type GetVariableQueryParameters = {
  id: number ;
  revisionId?: number | undefined ;
  postfix?: string | null | undefined ;
}

export type GetFetchedValueVariableQueryParameters = {
  id: number ;
  revisionId?: number | undefined ;
  postfix?: string | null | undefined ;
}

export type ExportVariableQueryParameters = {
  id: number ;
  revisionId?: number | undefined ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/variables";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.VariableDto, unknown, Types.CreateVariableDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.VariableDto, unknown, Types.CreateVariableDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateVariableDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function deleteUrl(id?: number | undefined, revisionId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/variables?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id?: number | undefined, revisionId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'delete',
      id as any,
      revisionId as any,
    ]);
}

export function useDeleteMutation<TContext>(id?: number | undefined, revisionId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id, revisionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id, revisionId),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteVariableQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteVariableQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!, options?.parameters?.revisionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!, data.revisionId ?? options?.parameters?.revisionId!),
  mutationKey: key,
});
}
  
export function searchUrl(search?: string | undefined, projectId?: number | undefined, revisionId?: number | undefined, isSystem?: boolean | null | undefined, variableType?: Types.VariableType | null | undefined, urlTypes?: Types.UrlType[] | null | undefined, systemVariableTypes?: Types.SystemVariableType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/variables?";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (projectId === null)
    throw new Error("The parameter 'projectId' cannot be null.");
else if (projectId !== undefined)
    url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "RevisionId=" + encodeURIComponent("" + revisionId) + "&";
if (isSystem !== undefined && isSystem !== null)
    url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
if (variableType !== undefined && variableType !== null)
    url_ += "VariableType=" + encodeURIComponent("" + variableType) + "&";
if (urlTypes !== undefined && urlTypes !== null)
    urlTypes && urlTypes.forEach(item => { url_ += "UrlTypes=" + encodeURIComponent("" + item) + "&"; });
if (systemVariableTypes !== undefined && systemVariableTypes !== null)
    systemVariableTypes && systemVariableTypes.forEach(item => { url_ += "SystemVariableTypes=" + encodeURIComponent("" + item) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfVariableListItemDto, unknown, Types.PagedResultOfVariableListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfVariableListItemDto, unknown, Types.PagedResultOfVariableListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchVariableQueryParameters): QueryKey;
export function searchQueryKey(search?: string | undefined, projectId?: number | undefined, revisionId?: number | undefined, isSystem?: boolean | null | undefined, variableType?: Types.VariableType | null | undefined, urlTypes?: Types.UrlType[] | null | undefined, systemVariableTypes?: Types.SystemVariableType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search, projectId, revisionId, isSystem, variableType, urlTypes, systemVariableTypes, offset, limit, sortBy, sortOrder,  } = params[0] as SearchVariableQueryParameters;

    return trimArrayEnd([
        'VariableClient',
        'search',
        search as any,
        projectId as any,
        revisionId as any,
        isSystem as any,
        variableType as any,
        urlTypes as any,
        systemVariableTypes as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'VariableClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as Types.VariableType | null | undefined,       context.queryKey[7] as Types.UrlType[] | null | undefined,       context.queryKey[8] as Types.SystemVariableType[] | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as number | null | undefined,       context.queryKey[11] as string | null | undefined,       context.queryKey[12] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfVariableListItemDto, TError = unknown>(dto: SearchVariableQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfVariableListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfVariableListItemDto, TError = unknown>(search?: string | undefined, projectId?: number | undefined, revisionId?: number | undefined, isSystem?: boolean | null | undefined, variableType?: Types.VariableType | null | undefined, urlTypes?: Types.UrlType[] | null | undefined, systemVariableTypes?: Types.SystemVariableType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfVariableListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfVariableListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfVariableListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  let projectId: any = undefined;
  let revisionId: any = undefined;
  let isSystem: any = undefined;
  let variableType: any = undefined;
  let urlTypes: any = undefined;
  let systemVariableTypes: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search, projectId, revisionId, isSystem, variableType, urlTypes, systemVariableTypes, offset, limit, sortBy, sortOrder,  } = params[0] as SearchVariableQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, projectId, revisionId, isSystem, variableType, urlTypes, systemVariableTypes, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfVariableListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(search, projectId, revisionId, isSystem, variableType, urlTypes, systemVariableTypes, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfVariableListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfVariableListItemDto | undefined) => Types.PagedResultOfVariableListItemDto, search?: string | undefined, projectId?: number | undefined, revisionId?: number | undefined, isSystem?: boolean | null | undefined, variableType?: Types.VariableType | null | undefined, urlTypes?: Types.UrlType[] | null | undefined, systemVariableTypes?: Types.SystemVariableType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(search, projectId, revisionId, isSystem, variableType, urlTypes, systemVariableTypes, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfVariableListItemDto | undefined) => Types.PagedResultOfVariableListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number, revisionId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/variables/{id}?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number, revisionId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'patch',
      id as any,
      revisionId as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, revisionId?: number | undefined, options?: Omit<UseMutationOptions<Types.VariableDto, unknown, Types.PatchVariableDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.VariableDto, unknown, Types.PatchVariableDto, TContext> {
  const key = patchMutationKey(id, revisionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchVariableDto) => Client.patch(id, dto, revisionId),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchVariableQueryParameters & {
  dto: Types.PatchVariableDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.VariableDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchVariableQueryParameters}): UseMutationResult<Types.VariableDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!, options?.parameters?.revisionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto, data.revisionId ?? options?.parameters?.revisionId!),
  mutationKey: key,
});
}
  
export function getUrl(id: number, revisionId?: number | undefined, postfix?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/variables/{id}?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
if (postfix !== undefined && postfix !== null)
    url_ += "postfix=" + encodeURIComponent("" + postfix) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.VariableDto, unknown, Types.VariableDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.VariableDto, unknown, Types.VariableDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetVariableQueryParameters): QueryKey;
export function getQueryKey(id: number, revisionId?: number | undefined, postfix?: string | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, revisionId, postfix,  } = params[0] as GetVariableQueryParameters;

    return trimArrayEnd([
        'VariableClient',
        'get',
        id as any,
        revisionId as any,
        postfix as any,
      ]);
  } else {
    return trimArrayEnd([
        'VariableClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,       context.queryKey[3] as number | undefined,       context.queryKey[4] as string | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.VariableDto, TError = unknown>(dto: GetVariableQueryParameters, options?: Omit<UseQueryOptions<Types.VariableDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.VariableDto, TError = unknown>(id: number, revisionId?: number | undefined, postfix?: string | null | undefined, options?: Omit<UseQueryOptions<Types.VariableDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.VariableDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.VariableDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let revisionId: any = undefined;
  let postfix: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, revisionId, postfix,  } = params[0] as GetVariableQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, revisionId, postfix, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.VariableDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id, revisionId, postfix),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.VariableDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.VariableDto | undefined) => Types.VariableDto, id: number, revisionId?: number | undefined, postfix?: string | null | undefined) {
  queryClient.setQueryData(getQueryKey(id, revisionId, postfix),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.VariableDto | undefined) => Types.VariableDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function bulkPatchUrl(): string {
  let url_ = getBaseUrl() + "/api/variables/bulk-patch";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function bulkPatchMutationKey(): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'bulkPatch',
    ]);
}

export function useBulkPatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.PatchVariableEntry[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchVariableEntry[], TContext> {
  const key = bulkPatchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (entries: Types.PatchVariableEntry[]) => Client.bulkPatch(entries),
    mutationKey: key,
  });
}
  
export function getFetchedValueUrl(id: number, revisionId?: number | undefined, postfix?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/variables/{id}/fetch-value?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
if (postfix !== undefined && postfix !== null)
    url_ += "postfix=" + encodeURIComponent("" + postfix) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFetchedValueDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getGetFetchedValueDefaultOptions() {
  return getFetchedValueDefaultOptions;
};
export function setGetFetchedValueDefaultOptions(options: typeof getFetchedValueDefaultOptions) {
  getFetchedValueDefaultOptions = options;
}

export function getFetchedValueQueryKey(dto: GetFetchedValueVariableQueryParameters): QueryKey;
export function getFetchedValueQueryKey(id: number, revisionId?: number | undefined, postfix?: string | null | undefined): QueryKey;
export function getFetchedValueQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, revisionId, postfix,  } = params[0] as GetFetchedValueVariableQueryParameters;

    return trimArrayEnd([
        'VariableClient',
        'getFetchedValue',
        id as any,
        revisionId as any,
        postfix as any,
      ]);
  } else {
    return trimArrayEnd([
        'VariableClient',
        'getFetchedValue',
        ...params
      ]);
  }
}
export function __getFetchedValue(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getFetchedValue(
      context.queryKey[2] as number,       context.queryKey[3] as number | undefined,       context.queryKey[4] as string | null | undefined,axiosConfig    );
}

export function useGetFetchedValueQuery<TSelectData = string, TError = unknown>(dto: GetFetchedValueVariableQueryParameters, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetFetchedValueQuery<TSelectData = string, TError = unknown>(id: number, revisionId?: number | undefined, postfix?: string | null | undefined, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFetchedValueQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let revisionId: any = undefined;
  let postfix: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, revisionId, postfix,  } = params[0] as GetFetchedValueVariableQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, revisionId, postfix, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getFetchedValue(context, axiosConfig) : __getFetchedValue,
    queryKey: getFetchedValueQueryKey(id, revisionId, postfix),
    ...getFetchedValueDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetFetchedValueData(queryClient: QueryClient, updater: (data: string | undefined) => string, id: number, revisionId?: number | undefined, postfix?: string | null | undefined) {
  queryClient.setQueryData(getFetchedValueQueryKey(id, revisionId, postfix),
    updater
  );
}

export function setGetFetchedValueDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function mergeUrl(): string {
  let url_ = getBaseUrl() + "/api/variables/merge";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function mergeMutationKey(): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'merge',
    ]);
}

export function useMergeMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.MergeVariablesDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MergeVariablesDto, TContext> {
  const key = mergeMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.MergeVariablesDto) => Client.merge(dto),
    mutationKey: key,
  });
}
  
export function exportUrl(id: number, revisionId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/variables/{id}/export?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let exportDefaultOptions: Omit<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryFn'>> = {
};
export function getExportDefaultOptions() {
  return exportDefaultOptions;
};
export function setExportDefaultOptions(options: typeof exportDefaultOptions) {
  exportDefaultOptions = options;
}

export function exportQueryKey(dto: ExportVariableQueryParameters): QueryKey;
export function exportQueryKey(id: number, revisionId?: number | undefined): QueryKey;
export function exportQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, revisionId,  } = params[0] as ExportVariableQueryParameters;

    return trimArrayEnd([
        'VariableClient',
        'export',
        id as any,
        revisionId as any,
      ]);
  } else {
    return trimArrayEnd([
        'VariableClient',
        'export',
        ...params
      ]);
  }
}
export function __export(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.export_(
      context.queryKey[2] as number,       context.queryKey[3] as number | undefined,axiosConfig    );
}

export function useExportQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: ExportVariableQueryParameters, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useExportQuery<TSelectData = Types.FileResponse, TError = unknown>(id: number, revisionId?: number | undefined, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExportQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let revisionId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, revisionId,  } = params[0] as ExportVariableQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, revisionId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __export(context, axiosConfig) : __export,
    queryKey: exportQueryKey(id, revisionId),
    ...exportDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setExportData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, id: number, revisionId?: number | undefined) {
  queryClient.setQueryData(exportQueryKey(id, revisionId),
    updater
  );
}

export function setExportDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function replaceUrlUrl(): string {
  let url_ = getBaseUrl() + "/api/variables/replace-url";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function replaceUrlMutationKey(): MutationKey {
  return trimArrayEnd([
      'VariableClient',
      'replaceUrl',
    ]);
}

export function useReplaceUrlMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ReplaceUrlDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ReplaceUrlDto, TContext> {
  const key = replaceUrlMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ReplaceUrlDto) => Client.replaceUrl(dto),
    mutationKey: key,
  });
}